import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import ReactGA from 'react-ga4';

const GAListener = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null;
};

export default GAListener;
